import ActivationForm from './model/form.model';

class ActivationController {
  constructor(ActivationApiService, StorageService, $window, $timeout, $state) {
    'ngInject';

    this.$window = $window;
    this.$timeout = $timeout;
    this.$state = $state;
    this.ActivationApiService = ActivationApiService;
    this.StorageService = StorageService;
  }

  $onInit() {
    this.checkIfActivated();
    this.model = new ActivationForm();
  }

  checkIfActivated() {
    let activationCode = this.StorageService.getItem('activation_code');
    let customerType = this.StorageService.getItem('customer_type');
    if (activationCode == '') {
      if (customerType == 'AFF') {
        this.$state.go('marketing');
      } else {
        this.$state.go('dashboard');
      }
    }
  }
}

export default ActivationController;



// WEBPACK FOOTER //
// ./client/app/pages/activation/activation.controller.js